// Auto-generated from ops/genesis/domain_topology.json by scripts/export_domain_topology_assets.mjs.
// Do not edit by hand.

export const DOMAIN_TOPOLOGY = {
  "schema_version": 1,
  "default_market": "international",
  "markets": {
    "international": {
      "base_domain": "123all.ai",
      "zone_name": "123all.ai",
      "aliases": [
        "international",
        "intl",
        "global",
        "overseas",
        "us",
        "eu"
      ],
      "domains": {
        "portal": "123all.ai",
        "www": "www.123all.ai",
        "console": "console.123all.ai",
        "auth": "auth.123all.ai",
        "api": "api.123all.ai",
        "gateway": "gateway.123all.ai",
        "cortex": "cortex.123all.ai",
        "cortex_a": "cortex.123all.ai",
        "cortex_b": "gateway.123all.ai",
        "dl": "dl.123all.ai",
        "app": "app.123all.ai",
        "get": "get.123all.ai",
        "bot": "bot.123all.ai",
        "agency": "agency.123all.ai",
        "agent": "agent.123all.ai",
        "agency_demo": "xinzhi.us",
        "agency_portal": "ai.xinzhi.us"
      },
      "routing": {
        "dns_endpoints": [
          "https://api.123all.ai",
          "https://gateway.123all.ai"
        ],
        "cdn_fallback_endpoints": [
          "https://gateway.123all.ai"
        ]
      },
      "prod": true
    },
    "domestic": {
      "base_domain": "123all.cn",
      "zone_name": "123all.cn",
      "aliases": [
        "domestic",
        "cn",
        "zh",
        "zh-cn",
        "china",
        "mainland"
      ],
      "domains": {
        "portal": "123all.cn",
        "www": "www.123all.cn",
        "console": "console.123all.cn",
        "auth": "auth.123all.cn",
        "api": "api.123all.cn",
        "gateway": "gateway.123all.cn",
        "cortex": "cortex.123all.cn",
        "cortex_a": "cortex.123all.cn",
        "cortex_b": "gateway.123all.cn",
        "dl": "dl.123all.cn",
        "app": "app.123all.cn",
        "get": "get.123all.cn",
        "bot": "bot.123all.cn",
        "agency": "agency.123all.cn",
        "agent": "agent.123all.cn",
        "commerce": "commerce.123all.cn"
      },
      "routing": {
        "dns_endpoints": [
          "https://api.123all.cn",
          "https://gateway.123all.cn"
        ],
        "cdn_fallback_endpoints": [
          "https://gateway.123all.cn"
        ]
      },
      "prod": true
    },
    "test": {
      "base_domain": "123xinzhi.com",
      "zone_name": "123xinzhi.com",
      "aliases": [
        "test",
        "staging",
        "qa",
        "jp"
      ],
      "domains": {
        "portal": "123xinzhi.com",
        "www": "www.123xinzhi.com",
        "console": "console.123xinzhi.com",
        "auth": "auth.123xinzhi.com",
        "api": "api.123xinzhi.com",
        "gateway": "gateway.123xinzhi.com",
        "cortex": "cortex.123xinzhi.com",
        "cortex_a": "cortex.123xinzhi.com",
        "cortex_b": "gateway.123xinzhi.com",
        "dl": "dl.123xinzhi.com",
        "app": "app.123xinzhi.com",
        "get": "get.123xinzhi.com",
        "bot": "bot.123xinzhi.com",
        "agency": "agency.123xinzhi.com",
        "agent": "agent.123xinzhi.com",
        "commerce": "commerce.123xinzhi.com"
      },
      "routing": {
        "dns_endpoints": [
          "https://api.123xinzhi.com",
          "https://gateway.123xinzhi.com"
        ],
        "cdn_fallback_endpoints": [
          "https://gateway.123xinzhi.com"
        ]
      },
      "prod": false
    }
  },
  "_markets_note": "markets 是「客户端可连接的服务面」，与 cf_dns_origins.json 的 zone（DNS 管理单位）不是一一对应。\n**[2026-10-20 切换]** domestic=**123all.cn**：国内分中心新品牌域，源站 121.22.251.24（cn-subcenter-01，gateway 另有 .38）、cortex→121.22.251.25（cn-center-01）。旧的 `qiliqiji.com` 在过渡期继续解析并由 nginx 服务（旧客户端不失效），但**不再作为新客户端的 domestic 市场域名**。\ntest=123xinzhi.com（prod:false）：**测试分中心域名**，当前指向日本节点 jp-subcenter-01（46.250.248.50，经 CF）。\n  客户端**不得自动选中** prod:false 的市场，只能由 dev 开关/显式环境变量选中，且界面必须标出「测试环境」。\n2026-09-24 更正：此前 domestic 指向 123xinzhi.com（把测试域名当成国内品牌面）⇒ 切「中国大陆」连的是测试域名。"
} as const;

export type DomainMarket = keyof typeof DOMAIN_TOPOLOGY.markets;
